<div
  class="lk-grid"
  [ngClass]="{
    'lk-grid--gap_small': gap === 'small',
    'lk-grid--gap_big': gap === 'big',
    'lk-grid--mobile-gap_small': mobileVerticalGap === 'small'
  }"
>
  <ng-content></ng-content>
</div>
